import { tv } from "tailwind-variants";

export const ImageContent = tv({
  base: 'w-full h-auto z-[0]'
})

export const ImageWrapper = tv({
  base: 'w-full md:w-[750px] h-auto m-auto z-[1] relative'
})